import { useCallback } from 'react';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';
import Pill from 'fe-design-base/molecules/Pill';

import { STATUS_UI } from 'features/notifications/statuses';
import { RequestType, TradeCoverClaim } from 'features/notifications/types';

import { toI18n } from 'util/i18n';

import { BaseRequest } from '../../BaseRequest';
import { ShiftDetails } from '../../ShiftDetails';

type OpenShiftProps = {
  request: TradeCoverClaim;
  setSelectedRequest?: (request: TradeCoverClaim, type: RequestType) => void;
};

type OpenShiftStatus = keyof (typeof STATUS_UI)['claim'];

const OpenShift = ({ request, setSelectedRequest }: OpenShiftProps) => {
  const {
    last_status_changed_at_secs,
    type,
    status,
    shift,
    requester,
    viewer_role,
    pending_approval_count,
    location,
  } = request;
  const statusValue = status as OpenShiftStatus;
  const pillUI = STATUS_UI.claim[statusValue];
  const { first_name, last_name, avatar } = requester || {};
  const name = requester ? `${first_name} ${last_name}` : 'Open shift claims';
  const avatarUrl = viewer_role === 'requester' ? avatar : undefined;

  const handleClick = useCallback(() => {
    setSelectedRequest?.(request, type);
  }, [setSelectedRequest, request, type]);

  return (
    <BaseRequest
      name={name}
      updatedAt={last_status_changed_at_secs}
      type={type}
      avatar={avatarUrl}
    >
      <Pill variant={pillUI?.variant}>{pillUI?.label}</Pill>

      {viewer_role === 'oam' && (
        <Text
          variant="captionBold"
          uppercase
          i18n="requests_feed.open_shift.responses"
          i18nProps={{ count: pending_approval_count || 0 }}
        />
      )}
      <ShiftDetails shift={shift} location={location} />
      {viewer_role === 'oam' && (
        <Button fullWidth onClick={handleClick}>
          {toI18n('requests_feed.open_shift.review')}
        </Button>
      )}
    </BaseRequest>
  );
};

export default OpenShift;
